// dependencies
import * as React from "react";

import { cn } from "../../../lib/utils";

// components
import { Badge, BadgeProps } from "../Badge";

export interface BadgeNumericProps extends Omit<BadgeProps, "children"> {
	/**
	 * The count to display in the badge
	 */
	count: number;
	/**
	 * The maximum count to display before showing overflow indicator (e.g., +999)
	 * @default 999
	 */
	overflowCount?: number;
}

/**
 * The BadgeNumeric component is used to display a numeric count.
 * To use it, include it as a child of the component you want to attach it to.
 */
const BadgeNumeric = (props: BadgeNumericProps) => {
	const { count, overflowCount = 999, dangerouslySetClassName, ...badgeProps } = props;

	// Determine display text
	const displayText = count > overflowCount ? `+${overflowCount}` : count.toString();

	// Determine typography class based on count
	const typographyClass = count > overflowCount ? "text-extra-small" : "text-caption";

	return (
		<Badge {...badgeProps} dangerouslySetClassName={cn(typographyClass, dangerouslySetClassName)}>
			{displayText}
		</Badge>
	);
};

export { BadgeNumeric };
